import { render, staticRenderFns } from "./MarketingEmailPanel.vue?vue&type=template&id=cd366408&scoped=true"
import script from "./MarketingEmailPanel.vue?vue&type=script&lang=js"
export * from "./MarketingEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailPanel.vue?vue&type=style&index=0&id=cd366408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd366408",
  null
  
)

export default component.exports